import { Box, Paper, Typography } from '@mui/material';

import type { ListingPriceFragment } from '@graphql/__generated__/graphql';
import { ListingPrice } from '@modules/_shared/components/ListingPrice';
import { useLocale } from '@shared/hooks/locale';

export type LivePriceValues = {
  offer_type?: string | null;
  sale_price?: number | null;
  price_unit?: string | null;
  rent_net?: number | null;
  rent_extra?: number | null;
  currency?: string | null;
  hide_price_on_portals?: boolean | null;
};

type ListingPricePreviewProps = {
  property: ListingPriceFragment['property'];
  values: LivePriceValues;
};

export const ListingPricePreview = ({
  property,
  values,
}: ListingPricePreviewProps) => {
  const { t } = useLocale();
  const hidePrice = values.hide_price_on_portals === true;

  const previewLot = {
    offer_type: values.offer_type ?? null,
    sale_price: hidePrice ? null : values.sale_price ?? null,
    price_unit: values.price_unit ?? null,
    rent_net: hidePrice ? null : values.rent_net ?? null,
    rent_extra: hidePrice ? null : values.rent_extra ?? null,
    currency: values.currency ?? null,
    hide_price_on_portals: values.hide_price_on_portals ?? null,
    property,
  } as ListingPriceFragment;

  return (
    <Box>
      <Typography
        variant="overline"
        sx={{ color: 'text.secondary', letterSpacing: 0.5 }}
      >
        {t('Preview')}
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          mt: 0.5,
          p: 2,
          borderRadius: 2,
          backgroundColor: theme =>
            (theme.vars ?? theme).palette.background.paper,
        }}
      >
        <ListingPrice listing={previewLot} />

        {hidePrice && (
          <Typography
            variant="caption"
            sx={{ display: 'block', mt: 1, color: 'text.secondary' }}
          >
            {t('Price hidden on portals (shown as "On request")')}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};
